import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BaseResetPasswordComponent } from 'src/app/shared/components/base-reset-password/base-reset-password.component';

@Component({
  selector: 'app-sgzp-app2-reset-password',
  templateUrl: './sgzp-app2-reset-password.component.html',
  styleUrls: [
    './sgzp-app2-reset-password.component.css',
    '../style/global.css',
  ],
})
export class SgzpApp2ResetPasswordComponent
  extends BaseResetPasswordComponent
  implements OnInit
{
  constructor(title: Title) {
    super();
    title.setTitle('パスワード再設定');
  }
  ngOnInit(): void {}
}
